import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { WeightLossFieldAnswers } from '../questions';

const questions = [
  {
    field: 'slendidWlus_MedicalConditions',
    label: 'Please check all current or past medical conditions:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'noneOfTheAbove',
          value: 'None of the below',
          uncheckOthers: true
        },
        {
          key: 'gastroparesis',
          value: 'Gastroparesis (Paralysis of your intestines)'
        },
        {
          key: 'triglyceridesOver600AtAnyPoint',
          value: 'Triglycerides over 600 at any point'
        },
        {
          key: 'pancreaticCancer',
          value: 'Pancreatic cancer'
        },
        {
          key: 'pancreatitis',
          value: 'Pancreatitis'
        },
        {
          key: 'type1Diabetes',
          value: 'Type 1 Diabetes'
        },
        {
          key: 'hypoglycemia',
          value: 'Hypoglycemia'
        },
        {
          key: 'insulinDependentDiabetes',
          value: 'Insulin-dependent diabetes'
        },
        {
          key: 'thyroidCancer',
          value: 'Thyroid cancer'
        },
        {
          key: 'familyHistoryOfThyroidCancer',
          value: 'Family history of thyroid cancer'
        },
        {
          key: 'familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome',
          value:
            'Personal or family history of Multiple Endocrine Neoplasia (MEN-2) syndrome'
        },
        {
          key: 'anorexiaOrBulimia',
          value: 'Anorexia or bulimia'
        },
        {
          key: 'currentSymptomaticGallstones',
          value: 'Current symptomatic gallstones'
        },
        {
          key: 'gallbladderRemoved',
          value: 'Gallbladder disease or past removal of your gallbladder'
        },
        {
          key: 'hypertensionHighBloodPressure',
          value: 'Hypertension (high blood pressure)'
        },
        {
          key: 'dyslipidemiaHighCholesterolOrTriglycerides',
          value: 'Dyslipidemia (high cholesterol or triglycerides)'
        },
        {
          key: 'sleepApnea',
          value: 'Sleep apnea'
        },
        {
          key: 'osteoporosis',
          value: 'Osteoporosis'
        },
        {
          key: 'mobilityIssuesWhichAreImpactedByBodyWeight',
          value: 'Mobility issues which are impacted by body weight'
        },
        {
          key: 'gastroesophagealRefluxDiseaseGERDRelatedToBodyWeight',
          value: 'Gastroesophageal reflux disease (GERD) related to body weight'
        },
        {
          key: 'polycysticOvarySyndromeWithInsulinResistance',
          value: 'Polycystic Ovary Syndrome with insulin resistance'
        },
        {
          key: 'liverDiseaseOrConditionsThatAffectTheLiver',
          value: 'Liver disease or conditions that affect the liver'
        },
        {
          key: 'heartDiseaseOrConditionsThatAffectTheHeart',
          value: 'Heart disease or conditions that affect the heart'
        },
        {
          key: 'metabolicSyndrome',
          value: 'Metabolic Syndrome'
        },
        {
          key: 'chronicKidneyDiseaseStage3OrGreater',
          value: 'Chronic Kidney Disease Stage 3 or greater'
        },
        {
          key: 'syndromeOfInappropriateAntidiureticHormone',
          value: 'Syndrome of Inappropriate Antidiuretic hormone'
        },
        {
          key: 'hypothyroidism,Hyperthyroidism,OrThyroidIssues',
          value: 'Hypothyroidism, Hyperthyroidism, or Thyroid Issues'
        },
        {
          key: 'prediabetes',
          value: 'Prediabetes'
        },
        {
          key: 'type2Diabetes',
          value: 'Type 2 Diabetes'
        }
      ]
    }
  }
] as const;

const _type = questions;
export type SlendidWeightlossFieldAnswers = Partial<
  QuestionAnswerMap<typeof _type>
> &
  WeightLossFieldAnswers;

export const SlendidWeightlossQuestions = _type;
